/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 10/02/22
 */

import { useEffect, useRef } from 'react';

export function usePrevious<T>(value: T, initial?: T) {
    const ref = useRef<T | undefined>(initial);

    useEffect(() => {
        ref.current = value;
    }, [value]);

    return ref.current as T;
}
